import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = 'Velmont Society',
  description = 'Private luxury concierge creating bespoke VIP experiences in Brazil. International standards. Brazilian insider access. By invitation only.',
  image = 'https://images.unsplash.com/photo-1722905501021-fe5dd192735c?auto=format&fit=crop&w=1200&q=80',
  url = '',
  type = 'website'
}) => {
  const siteUrl = process.env.REACT_APP_BACKEND_URL?.replace('/api', '') || '';
  const fullUrl = url ? `${siteUrl}${url}` : siteUrl;
  const fullTitle = title === 'Velmont Society' ? title : `${title} | Velmont Society`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={fullUrl} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
      
      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="theme-color" content="#050505" />
      <link rel="canonical" href={fullUrl} />
    </Helmet>
  );
};

export default SEO;
